var map = {
	"./Clicky_home.jpg": 8605,
	"./Clicky_main.jpg": 6207,
	"./Clicky_menu.jpg": 5489,
	"./LoopCell_level.png": 5347,
	"./LoopCell_main.png": 2418,
	"./Quoridor_game.png": 5362,
	"./Quoridor_main.png": 2879,
	"./Shadowbound_main.png": 1922,
	"./Shadowbound_run.png": 3714,
	"./Shadowbound_swap.png": 3244,
	"./Tradeworld_build.PNG": 8912,
	"./Tradeworld_leaderboard.PNG": 1825,
	"./Tradeworld_main.png": 1430,
	"./Tradeworld_mobile.PNG": 2684,
	"./Tradeworld_not_enough_resources.PNG": 6486,
	"./Tradeworld_tech.PNG": 1138,
	"./Tradeworld_trade.PNG": 3558,
	"./website_main.png": 7819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3240;